import React from 'react';
import { ListItem, ListItemText } from 'material-ui/List';

const FinishLoading = () => {
    const title = 'Finalizou carregamento da carga';

    return (
        <ListItem>
            <i className="material-icons">timer</i>
            <ListItemText primary={title} />
        </ListItem>
    );
}

export default FinishLoading;



// WEBPACK FOOTER //
// ./src/components/Timeline/Activities/FinishLoading.js